import React from 'react';
import { User } from 'lucide-react';
import { useEmployeePhoto } from '../../hooks/useEmployeePhoto';

const SIZES = {
  xs: 'w-8 h-8',
  sm: 'w-9 h-9',
  md: 'w-10 h-10',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24',
};

const ICON_SIZES = {
  xs: 'w-4 h-4',
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-8 h-8',
  xl: 'w-10 h-10',
};

/**
 * Circular profile avatar — shows uploaded photo or fallback icon.
 */
const EmployeeAvatar = ({
  employeeId,
  refreshKey = 0,
  size = 'md',
  className = '',
  borderClass = 'border-2 border-gray-200',
  fallbackClass = 'bg-gray-100 text-gray-400',
}) => {
  const { src, loading } = useEmployeePhoto(employeeId, refreshKey);
  const dim = SIZES[size] || SIZES.md;
  const icon = ICON_SIZES[size] || ICON_SIZES.md;

  return (
    <div
      className={`${dim} rounded-full overflow-hidden flex items-center justify-center shrink-0 ${borderClass} ${fallbackClass} ${className}`}
      aria-hidden={!src}
    >
      {src ? (
        <img
          src={src}
          alt=""
          className="w-full h-full object-cover"
        />
      ) : loading ? (
        <span className={`${icon} rounded-full bg-gray-200 animate-pulse block`} />
      ) : (
        <User className={icon} />
      )}
    </div>
  );
};

export default EmployeeAvatar;
